import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useRouter } from 'next/router';

const A: React.FC = () => {
    const { t } = useLang('shp3');
    const { locale = '' } = useRouter();
    const [enter, setEnter] = useState(false);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const st = setTimeout(() => {
                setEnter(true);
            }, 1000);
            return () => {
                clearTimeout(st);
            };
        }
    }, []);

    return (
        <section className={`${css.section} shp3-A GtmModuleData-section`} id="shp3-A" data-section-id={'shp3-A'} data-section-title={t('A_title')}>
            <div className="img pc">
                <picture>
                    <source srcSet={'https://websiteoss.ecoflow.com/upload/image/1761112955888/pc_kv.webp'} type="image/webp" />
                    <img
                        fetchpriority="high"
                        loading="eager"
                        src={'https://websiteoss.ecoflow.com/upload/image/1761112956411/pc_kv.jpg'}
                        alt={t('A_title')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>
            <div className="img h5">
                <picture>
                    <source srcSet={'https://websiteoss.ecoflow.com/upload/image/1761112955574/m_kv.webp'} type="image/webp" />
                    <img
                        fetchpriority="high"
                        loading="eager"
                        src={'https://websiteoss.ecoflow.com/upload/image/1761112955240/m_kv.jpg'}
                        alt={t('A_title')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>
            <div className={`info ${enter ? 'enter' : ''}`}>
                <div className={`inner`}>
                    <div className={`label ani-1 ${enter ? ' enter' : ''}`}>{t('A_label')}</div>
                    <div className={`title ani-2 ${enter ? ' enter' : ''}`}>{t('A_title')}</div>
                    <p className={`desc ani-3 ${enter ? ' enter' : ''}`}>{t('A_desc')}</p>
                </div>
            </div>
            {locale === 'ca' && <p className={`footer_text ani-3-5 ${enter ? ' enter' : ''}`}>{t('footer_text')}</p>}
        </section>
    );
};

export default A;
